<template>
    <div>
      <agent-transactions-report-list></agent-transactions-report-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  